import { render, staticRenderFns } from "./PreFaturaReceita.vue?vue&type=template&id=1ead1c7a"
import script from "./PreFaturaReceita.vue?vue&type=script&lang=js"
export * from "./PreFaturaReceita.vue?vue&type=script&lang=js"
import style0 from "./PreFaturaReceita.vue?vue&type=style&index=0&id=1ead1c7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports